import { render, staticRenderFns } from "./PayrollExpensesOverTime.vue?vue&type=template&id=68c7a90a"
import script from "./PayrollExpensesOverTime.vue?vue&type=script&lang=js"
export * from "./PayrollExpensesOverTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports